import React from 'react';
import { Card, CardContent, Typography, Box } from '@mui/material';
import { useNavigate } from 'react-router-dom';

interface KpiCardProps {
  title: string;
  value: number | string;
  icon: React.ReactNode;
  color?: 'primary' | 'success' | 'info' | 'warning' | 'error' | 'secondary';
  navigateTo?: string;
  /// 강조 표시 (예: 대기 신고가 있으면 빨간 뱃지)
  urgent?: boolean;
}

/// 대시보드 상단 KPI 카드. 클릭 시 지정 경로로 이동.
/// 기존 Dashboard.tsx 의 StatCard 스타일을 확장.
const KpiCard: React.FC<KpiCardProps> = ({
  title,
  value,
  icon,
  color = 'primary',
  navigateTo,
  urgent = false,
}) => {
  const navigate = useNavigate();

  const clickable = !!navigateTo;

  return (
    <Card
      onClick={() => navigateTo && navigate(navigateTo)}
      sx={{
        flex: '1 1 200px',
        minWidth: 200,
        cursor: clickable ? 'pointer' : 'default',
        transition: 'transform 0.2s, box-shadow 0.2s',
        borderLeft: urgent ? '4px solid' : 'none',
        borderLeftColor: urgent ? 'error.main' : 'transparent',
        '&:hover': clickable
          ? {
              transform: 'translateY(-4px)',
              boxShadow: 4,
            }
          : {},
      }}
    >
      <CardContent>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              width: 48,
              height: 48,
              borderRadius: '50%',
              bgcolor: `${color}.50`,
              color: `${color}.main`,
              flexShrink: 0,
            }}
          >
            {icon}
          </Box>
          <Box sx={{ flex: 1, minWidth: 0 }}>
            <Typography variant="caption" color="text.secondary" noWrap>
              {title}
            </Typography>
            <Typography variant="h5" fontWeight="bold">
              {typeof value === 'number' ? value.toLocaleString() : value}
            </Typography>
          </Box>
        </Box>
      </CardContent>
    </Card>
  );
};

export default KpiCard;
